import React from "react";
import styled from "styled-components";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 0.7rem;
  margin: 0.4rem 0;
  @media screen and (max-width: 1445px) {
  }
`;

export const Desc = ({ style, children, className }) => {
  return (
    <Styles className={className} style={style}>
      {children}
    </Styles>
  );
};
